var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "1100px", scrollable: "" },
          on: {
            input: function ($event) {
              return _vm.handleDialog($event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            color: "primary",
                            depressed: "",
                            rounded: _vm.rounded,
                            outlined: _vm.outlined,
                            disabled: _vm.disabled,
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_vm._v(" พิมพ์บาร์โค้ด ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _vm.item
            ? _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    [
                      _c("div", { staticClass: "primary--text" }, [
                        _vm._v(" ตั้งค่าบาร์โค้ด "),
                      ]),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "#A9A9A9", "x-small": "", icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.setDialog(false)
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v(" mdi-close "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-card-text", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-wrap flex-md-nowrap overflow-auto h-100",
                      },
                      [
                        _c("BarcodeSettingForm", {
                          attrs: {
                            pos1: _vm.pos1,
                            pos2: _vm.pos2,
                            pos3: _vm.pos3,
                            "show-barcode-number": _vm.showBarcodeNumber,
                            col: _vm.col,
                            row: _vm.row,
                            my: _vm.my,
                            mx: _vm.mx,
                            omy: _vm.omy,
                            omx: _vm.omx,
                            imy: _vm.imy,
                            "page-size": _vm.pageSize,
                            "font-size": _vm.fontSize,
                            copied: _vm.copied,
                          },
                          on: {
                            "update:pos1": function ($event) {
                              _vm.pos1 = $event
                            },
                            "update:pos2": function ($event) {
                              _vm.pos2 = $event
                            },
                            "update:pos3": function ($event) {
                              _vm.pos3 = $event
                            },
                            "update:showBarcodeNumber": function ($event) {
                              _vm.showBarcodeNumber = $event
                            },
                            "update:show-barcode-number": function ($event) {
                              _vm.showBarcodeNumber = $event
                            },
                            "update:col": function ($event) {
                              _vm.col = $event
                            },
                            "update:row": function ($event) {
                              _vm.row = $event
                            },
                            "update:my": function ($event) {
                              _vm.my = $event
                            },
                            "update:mx": function ($event) {
                              _vm.mx = $event
                            },
                            "update:omy": function ($event) {
                              _vm.omy = $event
                            },
                            "update:omx": function ($event) {
                              _vm.omx = $event
                            },
                            "update:imy": function ($event) {
                              _vm.imy = $event
                            },
                            "update:pageSize": function ($event) {
                              _vm.pageSize = $event
                            },
                            "update:page-size": function ($event) {
                              _vm.pageSize = $event
                            },
                            "update:fontSize": function ($event) {
                              _vm.fontSize = $event
                            },
                            "update:font-size": function ($event) {
                              _vm.fontSize = $event
                            },
                            "update:copied": function ($event) {
                              _vm.copied = $event
                            },
                          },
                        }),
                        !_vm.$vuetify.breakpoint.smAndDown
                          ? _c("v-spacer")
                          : _vm._e(),
                        !_vm.$vuetify.breakpoint.smAndDown
                          ? _c(
                              "div",
                              { staticClass: "mx-8 mt-10" },
                              [_c("v-divider", { attrs: { vertical: "" } })],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column align-center mx-auto",
                          },
                          [
                            _c("div", { staticClass: "mb-6 mt-1" }, [
                              _vm._v(" ตัวอย่าง "),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "modern-scrollbar flex-grow-1 overflow-auto",
                                attrs: { id: "barcodePreview" },
                              },
                              [
                                _c("BarcodePaper", {
                                  staticClass: "barcode-preview",
                                  attrs: {
                                    items: [_vm.item],
                                    width: _vm.pageSize.width,
                                    height: _vm.pageSize.height,
                                    "aspect-ratio": _vm.previewRatio,
                                    elements: _vm.elements,
                                    col: _vm.col,
                                    row: _vm.row,
                                    my: _vm.my,
                                    mx: _vm.mx,
                                    omy: _vm.omy,
                                    omx: _vm.omx,
                                    imy: _vm.imy,
                                    "font-size": _vm.fontSize,
                                    "show-barcode-number":
                                      _vm.showBarcodeNumber,
                                  },
                                  on: {
                                    "update:fontSize": function ($event) {
                                      _vm.fontSize = $event
                                    },
                                    "update:font-size": function ($event) {
                                      _vm.fontSize = $event
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-center align-center gap-6",
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "primary", icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setPage(_vm.page - 1)
                                      },
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                                  1
                                ),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(_vm.page) +
                                      " จาก " +
                                      _vm._s(_vm.itemChunked.length)
                                  ),
                                ]),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "primary", icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setPage(_vm.page + 1)
                                      },
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c("BarcodePreview", {
                        attrs: {
                          items: _vm.itemChunked,
                          elements: _vm.elements,
                          width: _vm.pageSize.width,
                          height: _vm.pageSize.height,
                          col: _vm.col,
                          row: _vm.row,
                          my: _vm.my,
                          mx: _vm.mx,
                          omy: _vm.omy,
                          omx: _vm.omx,
                          imy: _vm.imy,
                          "font-size": _vm.fontSize,
                          "show-barcode-number": _vm.showBarcodeNumber,
                        },
                        on: {
                          "update:fontSize": function ($event) {
                            _vm.fontSize = $event
                          },
                          "update:font-size": function ($event) {
                            _vm.fontSize = $event
                          },
                          submit: function ($event) {
                            return _vm.submit()
                          },
                        },
                      }),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-6 px-4",
                          attrs: { color: "primary", rounded: "", text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.setDialog(false)
                            },
                          },
                        },
                        [_vm._v(" ยกเลิก ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "px-4",
                          attrs: {
                            color: "primary",
                            depressed: "",
                            rounded: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.submit()
                            },
                          },
                        },
                        [_vm._v(" พิมพ์ ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }